/**
 * Loads YouTube's IFrame Player API exactly once and resolves when `window.YT`
 * is ready to construct players.
 *
 * Safe to call from multiple independent components: it reuses an already-loaded
 * API, dedupes concurrent loads via a shared promise, and *chains* any existing
 * `window.onYouTubeIframeAPIReady` handler (e.g. the Video Quiz player's) instead
 * of clobbering it.
 */
const IFRAME_API_SRC = 'https://www.youtube.com/iframe_api'
const SCRIPT_ID = 'youtube-iframe-api'

let readyPromise = null

export function loadYouTubeIframeApi() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('YouTube IFrame API needs a browser'))
  }
  // Already loaded (possibly by another player on the page).
  if (window.YT && window.YT.Player) {
    return Promise.resolve(window.YT)
  }
  if (readyPromise) {
    return readyPromise
  }

  readyPromise = new Promise((resolve) => {
    const previous = window.onYouTubeIframeAPIReady
    window.onYouTubeIframeAPIReady = () => {
      if (typeof previous === 'function') {
        previous()
      }
      resolve(window.YT)
    }

    if (!document.getElementById(SCRIPT_ID)) {
      const tag = document.createElement('script')
      tag.id = SCRIPT_ID
      tag.src = IFRAME_API_SRC
      const firstScript = document.getElementsByTagName('script')[0]
      firstScript.parentNode.insertBefore(tag, firstScript)
    }
  })

  return readyPromise
}
